import {BudgetModel} from "../../../pojo/bm-classes";
import {FormArray, FormControl, FormGroup} from "@angular/forms";
import {
  BmAnalyticsBarCharts,
  BmAnalyticsBarData,
  BmAnalyticsDataFg,
  BmAnalyticsPieCharts, BmAnalyticsPieData,
  BmFundAnalyticsFg
} from "../../../pojo/bm-form";
import {DateService} from "../../../../../../util/common/date.service";
import {BmBarChartsTypes} from "../../../pojo/bm-analytics-classes";

export class BmAnalyticsFormService {

  public static createForm(): FormGroup<BmAnalyticsDataFg> {
    return new FormGroup<BmAnalyticsDataFg>({
      periodBudgetData: this.createFundAnalyticsForm(),
      barCharts: this.createBarChartsForm(),
      pieCharts: this.createPieDataForm('budgetPieChart'),
    });
  }

  private static createFundAnalyticsForm(): FormGroup<BmFundAnalyticsFg> {
    return new FormGroup<BmFundAnalyticsFg>({
      capRequired: new FormControl<number>(0),
      totalExp: new FormControl<number>(0),
      investment: new FormControl<number>(0),
      mgmFee: new FormControl<number>(0),
      opExp: new FormControl<number>(0),
      orgExp: new FormControl<number>(0),
    });
  }

  private static createBarChartsForm(): FormGroup<BmAnalyticsBarCharts> {
    return new FormGroup<BmAnalyticsBarCharts>({
      capRequired: this.createBarDataForm(BmBarChartsTypes.capRequired),
      totalExp: this.createBarDataForm(BmBarChartsTypes.totalExp),
      investment: this.createBarDataForm(BmBarChartsTypes.investment),
      mgmFee: this.createBarDataForm(BmBarChartsTypes.mgmFee),
      opExp: this.createBarDataForm(BmBarChartsTypes.opExp),
      orgExp: this.createBarDataForm(BmBarChartsTypes.orgExp),
    });
  }

  private static createBarDataForm(chartId: string): FormGroup<BmAnalyticsBarData> {
    return new FormGroup<BmAnalyticsBarData>({
      chartId: new FormControl<string>(chartId),
      budget: new FormArray<FormControl<[number, number, number]>>([]),
    });
  }

  private static createPieDataForm(chartId: string): FormGroup<BmAnalyticsPieData> {
    return new FormGroup<BmAnalyticsPieData>({
      chartId: new FormControl<string>(chartId),
      series: new FormArray<FormControl<{y: number, name: string}>>([]),
    });
  }
}
